import { Injectable, inject } from '@angular/core';
import { InitiateService, User } from '@compumark/order-management-client';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class UserService {
  private initiate = inject(InitiateService);

  private userSubject$ = new BehaviorSubject<User>({});

  constructor() {
    this.initiate.getCurrentUser().subscribe((user: User) => {
      this.userSubject$.next(user);
    });
  }

  getCurrentUserObservable(): Observable<User> {
    return this.userSubject$.asObservable();
  }

  getCurrentUser(): User {
    return this.userSubject$.value;
  }
}
